import { defineComponent as _defineComponent } from 'vue'
import { ref, type Component } from 'vue'
import Top from '@/views/Top.vue'
// ログインユーザー向けトップ。現在はログイン状態に関わらず Top を表示するため未使用。
// ログイン後トップを再設計する際にコメントを解除して分岐を復活させる。
// import Top4Member from '@/views/Top4Member.vue'
import Top4BeautyOEM from '@/views/Top4BeautyOEM.vue'
import oemConfigs from '@/plugins/oem'

// OEM種別 → トップコンポーネントのマッピング
// 新しいOEMを追加する場合はここにimportとマッピングを追記する

export default /*#__PURE__*/_defineComponent({
  __name: 'TopCommon',
  setup(__props) {

const OEM_TOP_COMPONENTS: Record<string, Component> = {
  Top4BeautyOEM
}

const SITE_OEM = process.env.VUE_APP_SITE_OEM
const oemTopComponentName =
  SITE_OEM && oemConfigs[SITE_OEM] ? oemConfigs[SITE_OEM].topComponent : null

const currentComponent = ref<Component | string>(
  oemTopComponentName && OEM_TOP_COMPONENTS[oemTopComponentName]
    ? OEM_TOP_COMPONENTS[oemTopComponentName]
    : Top
)

return { __sfc: true,OEM_TOP_COMPONENTS, SITE_OEM, oemTopComponentName, currentComponent }
}

})